export default __webpack_public_path__ + "static/media/197.de732e72.gif";